export default "__VITE_ASSET__IOejKyoi__"